// import getLogger, { ILogger } from '../Core/Logger';

// const sdkLogger: ILogger = getLogger('[SDK-BOTS]:');

export interface ISDKbots {
    canSubscribeBots: () => Promise<any>;
    subscribeBots: () => Promise<any>;
}

export class SDKbots implements ISDKbots {
    public platform: any;

    constructor(platform: any) {
        this.platform = platform;
    }

    public async canSubscribeBots() {
        return await this.platform.canSubscribeBots();
    }

    public async subscribeBots() {
        return await this.platform.subscribeBots();
    }
}
